import Slice9Panel from "../../../../../lib/html5-software-library/src/ranj/components/scale9/Slice9Panel";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import KeyDecisionAnswer from "../../key-decisions/model/KeyDecisionAnswer";
import FeedbackEvent from "../event/FeedbackEvent";

export default class FeedbackAnswersMediator extends AbstractMediator {
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, feedbackPopupFactory, screenNavigator) {
        super(target, dispatcher, layoutManager, clickEaterFactory);
        this._languagePack = languagePack;
        this._feedbackPopupFactory = feedbackPopupFactory;
        this._screenNavigator = screenNavigator;

        this._answersButtons = [];
        this._popups = [];
        this._popupSkin = "";
    }

    initialize() {
        super.initialize();
        if (this._target.optimalAnswersTitle) {
            this._target.optimalAnswersTitle.text = this._languagePack.getText(`feedback.general.optimalAnswersTitle`);
        }
        if (this._target.yourAnswersTitle) {
            this._target.yourAnswersTitle.text = this._languagePack.getText(`feedback.general.yourAnswersTitle`);
        }
        this._target.READYfeedbackTitle.text = this._languagePack.getText(`feedback.general.readyFeedbackTitle`);
    }

    destroy() {
        for (let popup of this._popups) {
            popup.destroy();
        }
        super.destroy();
    }

    setPopupSkin(popupSkin) {
        this._popupSkin = popupSkin;
    }

    initAnswers() {
        for (let i = 0; i < 4; i++) {
            const ratings = ["Good", "Bad", "Medium"];
            let buttonY = 0;
            for (let rating of ratings) {
                var buttonAnswerEl = "ButtonAnswer" + rating + (i + 1);
                if (this._target[buttonAnswerEl] !== undefined) {
                    this._answersButtons[buttonAnswerEl] = this.createButton(this._target[buttonAnswerEl]);
                    this._answersButtons[buttonAnswerEl].addEventListener("rollover", this._mouseOverAnswer.bind(this, i));
                    this._answersButtons[buttonAnswerEl].addEventListener("rollout", this._mouseOutAnswer.bind(this, i));

                    buttonY = this._target[buttonAnswerEl].y - this._target[buttonAnswerEl].getBounds().height;
                    this._answersButtons[buttonAnswerEl].skin.alpha = 0;
                }
            }

            var answerFeedbackEl = "AnswerFeedback" + (i + 1);
            if (this._target[answerFeedbackEl] !== undefined) {
                this._target[answerFeedbackEl].alpha = 0;
            }

            // Generate Popups
            let popupScreen = this._feedbackPopupFactory.createPopup(this._target, this._popupSkin);
            popupScreen.setDefaultY(buttonY);
            popupScreen.hide();
            this._popups.push(popupScreen);

        }
    }

    _mouseOverAnswer(index) {
        this._popups[index].show();
    }
    _mouseOutAnswer(index) {
        this._popups[index].hide();
    }

    showLockedAnswersExplanation() {
        this._target.OptimalLockedExplanation.alpha = 1;
        this._target.OptimalLockedIcon.alpha = 1;
    }

    hideLockedAnswersExplanation() {
        this._target.OptimalLockedExplanation.alpha = 0;
        this._target.OptimalLockedIcon.alpha = 0;
    }

    /**
     * @param {Array<KeyDecisionAnswer>}
     */
    setAnswers(answers) {
       
        for (let i = 0; i < answers.length && i < 4; i++) {
            var capRating = answers[i].rating.charAt(0).toUpperCase() + answers[i].rating.slice(1);
            var buttonAnswerEl = "ButtonAnswer" + capRating + (i + 1);

            this._popups[i].enable();
            this._popups[i].setText(answers[i].answer);
            if (answers[i].answer.length <= FeedbackAnswersMediator.FEEDBACK_ANSWER_MAX_CHARACTER) {
                this._popups[i].disable();
                this._popups[i].hide();
            }
            if (this._target[buttonAnswerEl] !== undefined) {
                this._answersButtons[buttonAnswerEl].setLabel(this._trimAnswerText(answers[i].answer));
                this._answersButtons[buttonAnswerEl].skin.alpha = 1;

                if (answers[i].rating == KeyDecisionAnswer.GOOD_RATING && !answers[i].locked) {
                    if (this._answersButtons[buttonAnswerEl].skin.OptimalLockedAnswer !== undefined) {
                        this._answersButtons[buttonAnswerEl].skin.OptimalLockedAnswer.alpha = 0;
                    }
                } else {
                    if (this._answersButtons[buttonAnswerEl].skin.OptimalLockedAnswer !== undefined) {
                        this._answersButtons[buttonAnswerEl].skin.OptimalLockedAnswer.alpha = 1;
                    }
                }
            }

            var answerFeedbackEl = "AnswerFeedback" + (i + 1);
            if (this._target[answerFeedbackEl] !== undefined) {
                this._target[answerFeedbackEl].alpha = 1;
                this._target[answerFeedbackEl].text = answers[i].feedback;

            }
        }
    }

    hideAnswers() {
        for (let i = 0; i < 4; i++) {
            const ratings = ["Good", "Bad", "Medium"];
            for (let rating of ratings) {
                var buttonAnswerEl = "ButtonAnswer" + rating + (i + 1);
                if (this._target[buttonAnswerEl] !== undefined) {
                    this._answersButtons[buttonAnswerEl].skin.alpha = 0;
                }
                var answerFeedbackEl = "AnswerFeedback" + (i + 1);
                if (this._target[answerFeedbackEl] !== undefined) {
                    this._target[answerFeedbackEl].alpha = 0;
                }
            }
        }
    }

    _trimAnswerText(text) {
        if (text.length <= FeedbackAnswersMediator.FEEDBACK_ANSWER_MAX_CHARACTER) {
            return text;
        }
        text = text.substring(0, FeedbackAnswersMediator.FEEDBACK_ANSWER_MAX_CHARACTER);
        return text.substr(0, Math.min(text.length, text.lastIndexOf(" "))) + "...";
    }

    setDescription(description) {
        this._target.FeedbackKDdescription.text = description;
    }

    show(wait = 0, animationTime = 750) {
        return new Promise((resolve) => {
            createjs.Tween.get(this._target).wait(wait).to({ alpha: 1 }, animationTime, createjs.Ease.sineOut).call(() => { resolve() });
        });
    }

    hide(wait = 0, animationTime = 200) {
        return new Promise((resolve) => {
            createjs.Tween.get(this._target).wait(wait).to({ alpha: 0 }, animationTime, createjs.Ease.sineOut).call(() => { resolve() });
        });
    }

    slideInBottomAndFadeIn(wait = 0, animationTime = 750) {
        let marginX = 40;
        return new Promise((resolve) => {
            let initY = this._target.y;
            this._target.alpha = 0;
            this._target.y += marginX;
            createjs.Tween.get(this._target).wait(wait).to({ alpha: 1, y: initY }, animationTime, createjs.Ease.sineOut).call(() => { resolve() });
        });
    }

    slideInRight(wait = 0, animationTime = 750) {
        return new Promise((resolve) => {
            let initX = this._target.x;
            this._target.x -= 20;
            this._target.alpha = 0;
            createjs.Tween.get(this._target).wait(wait).to({ alpha: 1, x: initX }, animationTime, createjs.Ease.sineOut).call(() => { resolve() });
        });
    }

    slideOut(wait = 0, animationTime = 200) {
        createjs.Tween.get(this._target).wait(wait).to({ alpha: 0 }, animationTime, createjs.Ease.sineOut);
    }

    get skin() {
        return this._target;
    }

    get keyDecision() {
        return this._keyDecision;
    }
}
FeedbackAnswersMediator.FEEDBACK_ANSWER_MAX_CHARACTER = 115;